import { Radio } from "antd";
import { RadioChangeEvent } from "antd/lib/radio";

interface RadioGenderProps {
  value?: string;
  onChange?: (value: string) => void;
}

export const RadioGender = ({ value, onChange }: RadioGenderProps) => {
  const handleChange = (e: RadioChangeEvent) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Radio.Group value={value} onChange={handleChange}>
      <Radio value="male">Male</Radio>
      <Radio value="female">Female</Radio>
    </Radio.Group>
  );
};
